import { useMemo } from 'react'

import { parseISO } from 'date-fns'

import { type OrchestratedListingDetails } from '@b-stock/fe-core/bstock-next/queries'

import { usePermission, PermissionGranule } from '@/helpers/permissions'

import {
  MoreFromSellerContent,
  type MoreFromSellerVariant,
} from './MoreFromSellerContent'

export const MoreFromSeller = ({
  listing,
  variant = 'section',
}: {
  listing: OrchestratedListingDetails
  variant?: MoreFromSellerVariant
}) => {
  const endDate = useMemo(() => {
    if (listing.dateVisibilityEnds) {
      return parseISO(listing.dateVisibilityEnds)
    }
    // Return a falsy value if dateVisibilityEnds is not defined
    return null
  }, [listing])

  const canViewMoreFromSeller = usePermission(
    PermissionGranule.FEBP_LISTING_DETAIL_MORE_FROM_SELLER
  )

  if (canViewMoreFromSeller && endDate && listing.seller.storefront) {
    return (
      <MoreFromSellerContent
        currentListing={listing}
        excludeListingId={listing._id}
        storefront={listing.seller.storefront}
        variant={variant}
      />
    )
  }
  return null
}
